export default {
    SET_ME(state, payload) {
        state.me = payload
    },
}
